import axios from "axios";
import axiosUrl from "./axios.service";
import store from "../store/index";
const API_URL = axiosUrl.getAxiosUrl();

class AIService {
  async getAISettings() {
    return await axios.get(API_URL + "/ai/getAISettings").then((response) => {
      if (response.status === 200) {
        store.commit("chat/fillSettings", response.data);
      }
    });
  }
}

export default new AIService();
